/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { RouteResourceResponse } from '../../../../../common/types.tsx';

export const setSsrDataPromise = (slice: RouteResourceResponse): RouteResourceResponse =>
	slice.promise === null ? { ...slice, promise: Promise.resolve(slice.data) } : slice;
